import { $authHost } from "../../http";
import { 
    PROBE_GET_REQUEST, PROBE_GET_SUCCESS, PROBE_GET_ERROR, 
    PROBE_GET_BY_KEY_REQUEST, PROBE_GET_BY_KEY_SUCCESS, PROBE_GET_BY_KEY_ERROR, 
    PROBE_ADD_REQUEST, PROBE_ADD_SUCCESS, PROBE_ADD_ERROR, 
    PROBE_EDIT_REQUEST, PROBE_EDIT_SUCCESS, PROBE_EDIT_ERROR, 
    PROBE_DELETE_REQUEST, PROBE_DELETE_SUCCESS, PROBE_DELETE_ERROR
} from "../constants/probeConstants";

export const getProbes = (args) => async (dispatch) => {
    try {
        dispatch({
            type: PROBE_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/probe/query",
            args || {},
            config,
        );
        dispatch({
            type: PROBE_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: PROBE_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getProbeByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: PROBE_GET_BY_KEY_REQUEST
        });

        const {data} = await $authHost.get(
            `/api/v1/probe/${id}`,
        );
        dispatch({
            type: PROBE_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: PROBE_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addProbe = ({ createdAt, schema, data, stateId, serviceId, objectReferralId }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: PROBE_ADD_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.post(
            "/api/v1/probe",
            { createdAt, schema, data, stateId, serviceId, objectReferralId },
            config,
        );
        dispatch(getProbes(queryArgs || {}));
        dispatch({
            type: PROBE_ADD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: PROBE_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const editProbe = ({ id, createdAt, schema, data, stateId, serviceId, objectReferralId }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: PROBE_EDIT_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.put(
            "/api/v1/probe",
            { id, createdAt, schema, data, stateId, serviceId, objectReferralId },
            config,
        );
        dispatch(getProbes(queryArgs || {}));
        dispatch({
            type: PROBE_EDIT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: PROBE_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteProbe = (id, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: PROBE_DELETE_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.delete(
            "/api/v1/probe",
            { data: { id } },
            config,
        );
        dispatch(getProbes(queryArgs || {}));
        dispatch({
            type: PROBE_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: PROBE_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

